<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader />
  
      <!-- Tax Form -->
      <div class="container mt-4">
        <div class="row">
          <div class="col-12">
            <h2>Add New Tax</h2>
            <form @submit.prevent="handleSubmit">
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="name">Tax Name</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="name" 
                    v-model="form.name" 
                    placeholder="e.g., VAT, GST, Sales Tax" 
                    required
                  >
                </div>
              </div>
              <!-- Percentage Input -->
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="percentage">Tax Percentage (%)</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="percentage" 
                    v-model="form.percentage" 
                    placeholder="e.g., 15" 
                    min="0"
                    max="100"
                    step="0.01"
                    required
                  >
                </div>
              </div>
  
              <div class="form-row">
            <div class="form-group col-md-12">
              <div class="form-check">
                <input 
                  type="checkbox" 
                  class="form-check-input" 
                  id="nettotal" 
                  v-model="form.nettotal"
                >
                <label class="form-check-label" for="nettotal">
                  Apply to Net Total?
                </label>
                <small class="text-muted d-block">
                  If enabled, tax will be calculated on the net total (excluding other taxes).
                </small>
              </div>
            </div>
          </div>
              <!-- Buttons -->
              <div class="form-row">
                <div class="form-group col-12 d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                  <button type="submit" class="btn btn-primary">Save Tax</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  
      <!-- Footer -->
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: '',
          percentage: '',
        },
        currentDate: '',
        currentTime: '',
        productId: null, 
      };
    },
    mounted() {
      this.productId = this.$route.params.id; 
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      async handleSubmit() {
        const token = localStorage.getItem('authToken');
        const branchId = 1; // Hardcoded as per requirements
  
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          // Step 1: Create the tax
          const taxResponse = await fetch(`${this.$BASE_API_URL}/api/taxes`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              branchId: branchId,
              name: this.form.name,
              percentage: parseFloat(this.form.percentage),
              nettotal: this.form.nettotal,
            }),
          });
  
          const taxData = await taxResponse.json();
  
          if (!taxResponse.ok) {
            throw new Error(taxData.message || 'Failed to create tax');
          }
  
          // Step 2: Assign tax to product
          const assignResponse = await fetch(`${this.$BASE_API_URL}/api/products/set_tax/${this.productId}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              taxId: taxData.data.id,
              branchId: branchId
            }),
          });
  
          const assignData = await assignResponse.json();
  
          if (!assignResponse.ok) {
            throw new Error(assignData.message || 'Failed to assign tax to product');
          }
  
          this.$toast.success('Tax created and assigned successfully!');
            this.$router.go(-1);
        } catch (error) {
          console.error('Error:', error);
          this.$toast.error(`Error: ${error.message}`);
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      cancelForm() {
        this.$router.go(-1); // Go back to previous page
      },
    },
  };
  </script>
  
  <style scoped>
  /* Reuse your existing form styles */
  .form-control {
    margin-bottom: 15px;
  }
  .btn {
    padding: 8px 20px;
  }
  .btn-primary {
    background-color: #4CAF50;
    border-color: #4CAF50;
  }
  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
  }
  </style>